import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextEditor } from '../../ui/TextEditor';

interface Props {
  disabled?: boolean;
}

export const InvestmentDetailsTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <TextEditor
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.investmentinformation.fields.investmentDetails.label')}
      fieldName="descriptions.investmentDetails"
      placeholder={t('dashboard.assets.addedit.investment.investmentinformation.fields.investmentDetails.placeholder')}
    />
  );
};
